import React from 'react';

const Settings: React.FC = () => {
  return <div>Settings Component</div>;
};

export default Settings;
